// Azure AD MSAL Configuration
// In production, these values should come from environment variables set during build
export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_AD_CLIENT_ID,
    authority: import.meta.env.VITE_AZURE_AD_AUTHORITY,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true, // Enable auto-navigation after successful login
  },
  cache: {
    cacheLocation: 'sessionStorage', // Secure: cleared when browser tab closes
    storeAuthStateInCookie: false,
  },
};

// ✅ IMPORTANT: Scope must use the BACKEND API's Client ID, not the Frontend's!
// The frontend authenticates users, but requests tokens FOR the backend API
// Format: api://{backend-api-client-id}/{scope-name}
const apiScope = import.meta.env.VITE_API_SCOPE;

export const loginRequest = {
  scopes: [apiScope],
};

export const tokenRequest = {
  scopes: [apiScope],
};

// API endpoint
export const apiConfig = {
  baseUrl: import.meta.env.VITE_API_BASE_URL || 'https://localhost:7193',
};
